const TIMEFRAME_VALUES = Object.freeze({
  '5D': {
    graphqlTimeframe: '5days',
    readableTimeframe: 'Last 5 Days'
  },
  '1M': {
    graphqlTimeframe: '1month',
    readableTimeframe: 'Last Month'
  },
  '3M': {
    graphqlTimeframe: '3months',
    readableTimeframe: 'Last 3 Months'
  },
  '6M': {
    graphqlTimeframe: '6months',
    readableTimeframe: 'Last 6 Months'
  },
  YTD: {
    graphqlTimeframe: 'ytd',
    readableTimeframe: 'YTD'
  },
  '1Y': {
    graphqlTimeframe: '1year',
    readableTimeframe: 'Past Year'
  }
});

export const timeframes = Object.keys(TIMEFRAME_VALUES);
export const readableTimeframes = Object.values(TIMEFRAME_VALUES).map(
  timeframe => timeframe.readableTimeframe
);
export const graphqlTimeframes = Object.values(TIMEFRAME_VALUES).map(
  timeframe => timeframe.graphqlTimeframe
);

export const graphqlTimeframe = timeframe => TIMEFRAME_VALUES[timeframe].graphqlTimeframe;
export const readableTimeframe = timeframe => TIMEFRAME_VALUES[timeframe].readableTimeframe;
